import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText
} from '@mui/material';

import { Trans } from "@lingui/macro";

interface BringLiveConfirmationModalProps{
    showConfirmationModal:boolean,
    closeConfirmationModal:any,
    goLive:any
}

export class BringLiveConfirmationModal extends React.Component<BringLiveConfirmationModalProps, {}>
{
  
  public constructor(props: BringLiveConfirmationModalProps)
  {
    super(props)
  }

  render()
  {
    return (
      <Dialog
        open={this.props.showConfirmationModal}
        onClose={() => this.props.closeConfirmationModal()}
        PaperProps={{ style: { background: "#1d1c25" } }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "white" }} id="alert-dialog-title">
          <Trans id="dpc-title">Inizia diretta in anticipo</Trans>
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "white" }} id="alert-dialog-description">
            <Trans id="dpc-text">Confermi di voler iniziare la diretta in anticipo?</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => this.props.closeConfirmationModal()}
            style={{ color: "white" }}
            >Indietro</Button>
          <Button 
            style={{ backgroundColor: "#920073" }}
            variant="contained" 
            onClick={() => this.props.goLive()} autoFocus>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    )
  };
}